const content = {
  title: "Nuance in Meaning and Expression",
  explanation: `
At C1 level, strong users move beyond correctness to rhetorical precision and pragmatic control.
Example: The results show a difference. / The results indicate a statistically significant difference.

Small lexical and structural changes can shift tone, certainty, and speaker distance.
Example: It will happen. / It appears likely to happen.

Nuance allows a speaker to sound objective, cautious, critical, or diplomatic without changing core facts.
Example: The policy failed. / The policy appears to have produced limited outcomes.

This unit trains you to choose forms that match intention, audience, and register.
Example: We need more data. / Further evidence is required before drawing conclusions.
  `,
  rules: [
    "Different word choices can signal varying levels of certainty or caution",
    "Adding modal or reporting structures can distance the speaker from a claim",
    "Certain adverbs subtly change emphasis or implication",
    "Formality often depends on lexical choice rather than structure",
    "Writers may soften or strengthen statements without changing the core meaning",
    "Grammatically correct sentences can still differ significantly in nuance"
  ],
  examples: [
    "She will complete the project by Friday.",
    "She is expected to complete the project by Friday.",
    "The results show a big difference between the groups.",
    "The results indicate a significant difference between the groups.",
    "He resolved the issue.",
    "He managed to resolve the issue.",
    "The proposal is interesting.",
    "The proposal is interesting, but somewhat unclear."
  ]
};

export default content;


